import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProgressBarComponent {
    @Input() public max = 100;
    @Input() public value: number;
    @Input() public timeLeft: number;

    constructor() {}
}
